import React from 'react'
import { Link } from 'react-router-dom'

import AddIcon from 'Assets/Images/icons/add'

export const LinkAddUnstyled = props => (
  <div
    className={props.className}
    onClick={props.onClickHandler}
    cypress_id={props.cypress_id}
  >
    <AddIcon />
    <Link to={props.to || ''} />
  </div>
)
